import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<NotificationComponent>) {}

  ngOnInit() {
    setTimeout(() => {
      this.dialogRef.close();
    }, 3000);
  }
}
